import { ProductList } from '@/app/entities/products/ui/ProductList'

export const Products = () => {
    return <ProductList />
}
